import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme) => ({
  homeTextFieldParent: {
    boxShadow: "-2px 4px 5px 0px rgba(0, 0, 0, 0.1)",
    padding: "0 15px",
    height: 62,
    background: "#fff",
    width: "50%",
  },
  textFieldParent: {
    boxShadow: "-2px 4px 5px 0px rgba(0, 0, 0, 0.1)",
    padding: "0 15px",
    height: 62,
    background: "#fff",
    width: "70%",
  },
  textField: {
    width: "100%",
    borderRadius: 2,
    fontSize: 20,
    margin: "5px 0px",
    [theme.breakpoints.down("sm")]: {
      margin: "10px 0px",
    },
  },
}));

export default function TextFields(props) {
  const classes = useStyles();
  let atHomeScreen = props.atHomeScreen;
  let amount = `R$ ${
    props?.amount
      ? props?.amount
          ?.toFixed(2)
          .replace(".", ",")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
      : "0,00"
  }
  `;

  return (
    <div
      className={
        atHomeScreen ? classes.homeTextFieldParent : classes.textFieldParent
      }
    >
      <TextField
        id="standard-read-only-input"
        label={
          atHomeScreen ? "Valor dos débitos selecionados:" : "Valor dos débitos"
        }
        className={classes.textField}
        margin="normal"
        InputProps={{
          style: { fontSize: 25 },
          disableUnderline: true,
          readOnly: true,
          value: amount,
        }}
      />
    </div>
  );
}
